module.exports = __webpack_public_path__ + "img/3.521f695f.jpg";